import { render, staticRenderFns } from "./pointGrantNum.vue?vue&type=template&id=4ac80894&"
import script from "./pointGrantNum.vue?vue&type=script&lang=js&"
export * from "./pointGrantNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports